export default "__VITE_ASSET__7c_p4IyH__"